import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'organization',
    name: 'organization',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/organization/staff',
    meta: { title: '组织管理', icon: 'svg:menu-employee', order: 105 },
    children: [
      {
        path: 'staff',
        name: 'organization_staff',
        component: () => import('@/views/Organization/Staff/index.vue'),
        meta: { title: '员工列表', order: 2 }
      },
      {
        path: 'department',
        name: 'organization_department',
        component: () => import('@/views/Organization/Department/index.vue'),
        meta: { title: '部门管理', order: 3 }
      },
      {
        path: 'job',
        name: 'organization_job',
        component: () => import('@/views/Organization/Job/index.vue'),
        meta: { title: '岗位管理', order: 4 }
      },
      {
        path: 'job-grade',
        name: 'organization_job_grade',
        component: () => import('@/views/Organization/JobGrade/index.vue'),
        meta: { title: '职级管理', order: 5 }
      },
      {
        path: 'structure',
        name: 'organization_structure',
        component: () => import('@/layout/routerView.vue'),
        redirect: '/staff/organization/group',
        meta: { title: '集团组织', order: 1 },
        children: [
          {
            path: 'group',
            name: 'organization_structure_group',
            component: () => import('@/views/Organization/Structure/group.vue'),
            meta: { title: '集团管理' }
          },
          {
            path: 'zhanqu',
            name: 'organization_structure_zhanqu',
            component: () => import('@/views/Organization/Structure/zhanqu.vue'),
            meta: { title: '战区管理' }
          },
          {
            path: 'daqu',
            name: 'organization_structure_daqu',
            component: () => import('@/views/Organization/Structure/daqu.vue'),
            meta: { title: '大区管理' }
          },
          {
            path: 'quyu',
            name: 'organization_structure_quyu',
            component: () => import('@/views/Organization/Structure/quyu.vue'),
            meta: { title: '区域管理' }
          },
          {
            path: 'qudui',
            name: 'organization_structure_qudui',
            component: () => import('@/views/Organization/Structure/qudui.vue'),
            meta: { title: '区队管理' }
          },
          {
            path: 'shop',
            name: 'organization_structure_shop',
            component: () => import('@/views/Organization/Structure/shop.vue'),
            meta: { title: '当店管理' }
          }
        ]
      }
    ]
  }
]

export default routes
